import { defineMessages } from 'react-intl';

export default defineMessages({
  disabledTooltip: {
    defaultMessage: 'Rate Browser unavailable for fulfillments',
    id: 'jlAkfZ',
    description: 'shown to users when the order is set to be fulfilled through a 3rd party',
  },
  browseRates: {
    description: 'open rate browser modal button label',
    id: 'ypzF74',
    defaultMessage: 'Browse Rates',
  },
});
